import { useParams, useSearchParams } from 'react-router-dom';

const useCategory = () => {
  const { category } = useParams();
  const [searchParams] = useSearchParams();

  const isSearchPage = category === 'search';

  const isSearchPageQueryExists = isSearchPage && !searchParams.get('q');

  return {
    isSearchPage,
    isSearchPageQueryExists,
  };
};

export default useCategory;
